export interface Role {
  label: string
  value: string
}
export interface NavigationItem {
    label: string
    icon?: string
    to?: string
    children?: NavigationItem[]
    roles?: Role[]
    defaultOpen?: boolean
}
export type RolesType = Record<string, Role>
export const Roles: Record<string, Role> = {
  admin: {
    label: 'Admin',
    value: 'admin'
  },
  planner: {
    label: 'Planner',
    value: 'planner'
  },
  operations: {
    label: 'Operations',
    value: 'operations'
  },
  testing: {
    label: 'Testing Group',
    value: 'testing'
  },
  viewer: {
    label: 'Viewer',
    value: 'viewer'
  },
  deactivated: {
    label: 'Deactivated',
    value: 'deactivated'
  }
}

export function getRoleFromValue(value: string) {
  return Object.values(Roles).find(role => role.value === value)
}

export const Navigation: NavigationItem[] = [
  { label: 'Dashboard', icon: 'i-heroicons-chart-pie', to: '/', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
  { label: 'Packages', icon: 'i-fa6-solid-box', to: '/packages', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
  { label: 'Pipe Testing', to: '/pipe-testing', icon: 'i-mdi-pipe-leak', roles: [Roles.testing!, Roles.planner!, Roles.viewer!, Roles.operations!] },
  { label: 'Planner Tools', icon: 'i-fa6-solid-screwdriver-wrench', children: [
      { label: 'Ebuilt Constraints', to: '/planners/ebuilts', icon: 'i-fa6-solid-file-circle-xmark', roles: [Roles.planner!, Roles.operations!] },
      { label: 'Aconex Package Updates', to: '/planners/package-updates', icon: 'i-fa6-solid-file-circle-exclamation', roles: [Roles.planner!, Roles.operations!] },
    ],
    defaultOpen: true,
    roles: [Roles.planner!, Roles.operations!]
  },
  { label: 'Data Info', to: '/data', icon: 'i-material-symbols-database-sharp', roles: [Roles.testing!, Roles.planner!, Roles.viewer!, Roles.operations!] },
    { label: 'Raw Data', icon: 'i-material-symbols-database-search-rounded', children: [
        { label: 'Qtrax', to: '/data/qtrax', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
        { label: 'PCN', to: '/data/pcn', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
        { label: 'Schedule', to: '/data/schedule', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
        { label: 'Rates', to: '/data/rates', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
        { label: 'Aconex', to: '/data/aconex', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
        { label: 'ITRs', to: '/data/itrs', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
      ],
      roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!]
    },
    { label: 'Settings & Metrics', icon: 'i-heroicons-cog', to: '/settings', roles: [Roles.planner!, Roles.testing!, Roles.viewer!, Roles.operations!] },
    { label: 'About', icon: 'i-heroicons-information-circle', to: '/about' },
]